import { useEffect, useState } from 'react';
import { Button, Flex, Text, Heading } from '@chakra-ui/react';
import { httpClient } from '@texas/api/httpClient/httpClient';
import { useTranslation } from 'react-i18next';
import { fadeInBottomAnimation } from '@texas/resources/animations/animations';

export function VersionMismatchBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleVersionMismatch = () => {
      setShowBanner(true);
    };

    httpClient.onVersionMismatch.subscribe(handleVersionMismatch);

    return () => {
      httpClient.onVersionMismatch.unsubscribe(handleVersionMismatch);
    };
  }, []);

  if (!showBanner) {
    return null;
  }

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <Flex
      position="fixed"
      bottom={12}
      left={12}
      right={12}
      zIndex={9999}
      animation={fadeInBottomAnimation()}
    >
      <Flex
        bg="white"
        padding={12}
        borderRadius="md"
        boxShadow="base"
        flexDir="column"
        gap={4}
      >
        <Heading fontSize="xl" color="black">
          {t('versionMismatch.title')}
        </Heading>
        <Text color="black">{t('versionMismatch.message')}</Text>
        <Button
          width="fit-content"
          size="sm"
          variant="texas-solid"
          onClick={handleRefresh}
        >
          {t('versionMismatch.refreshButton')}
        </Button>
      </Flex>
    </Flex>
  );
}
